/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.19/esri/copyright.txt for details.
*/
const e={drawCompleteKey:"c",redoKey:"r",undoKey:"z",vertexAddKey:"f",panKey:" "};export{e as KEYS};
